"use client";

import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import type { CrossSellOfferCopy } from "@/libs/cross-sell-v2";

type CrossSellComingSoonModalProps = {
  offer: CrossSellOfferCopy;
  open: boolean;
  onClose: () => void;
};

export default function CrossSellComingSoonModal({ offer, open, onClose }: CrossSellComingSoonModalProps) {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[99999]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
                <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-indigo-600">
                  Coming soon
                </div>
                <Dialog.Title className="text-lg font-bold text-gray-900">{offer.teaseTitle}</Dialog.Title>
                <p className="mt-3 text-sm leading-relaxed text-gray-600">{offer.teaseBody}</p>
                <button
                  type="button"
                  onClick={onClose}
                  className="mt-6 w-full rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90"
                >
                  Got it. I&apos;ll check back later
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
